import { Input } from '@fullscreendigital/carrefour-dex-fe'

export const getColumns = [
  {
    title: 'First name',
    field: 'firstName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Last name',
    field: 'lastName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Email address',
    field: 'emailAddress',
    align: 'left',
    type: 'string'
  },
  {
    title: 'AD user name',
    field: 'adUserName',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Global ID',
    field: 'globalId',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'User ID',
    field: 'userId',
    align: 'left',
    type: 'string',
    collapsible: true
  }
]

export const getFilters = () => [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    filter: <Input type="text" name="firstName" label="First Name" variant="outlined" value="" />
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    filter: <Input type="text" name="lastName" label="Last Name" variant="outlined" value="" />
  },
  {
    name: 'emailAddress',
    label: 'Email',
    type: 'text',
    filter: <Input type="text" name="emailAddress" label="Email" variant="outlined" value="" />
  },
  {
    name: 'adUserName',
    label: 'AD User Name',
    type: 'text',
    filter: <Input type="text" name="adUserName" label="AD User Name" variant="outlined" value="" />
  }
]
